'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './events.routes';
/*import 'ui-select';*/

import 'angular-xeditable';

// NOTE: Import y Require no hacen que el webapck genere un chunk nuevo. La unica opcion es require.ensure
import 'textangular';
import 'textangular/dist/textAngular-sanitize';
import 'ng-file-upload';
import CodeMirror from 'codemirror';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import 'codemirror/mode/javascript/javascript.js';

// Make CodeMirror available globally so the modes' can register themselves.
//window.CodeMirror = CodeMirror;
import 'angular-ui-codemirror';


// INVESTIGAR: https://luwenhuang.wordpress.com/2015/01/28/angular-webpack-and-gulp-for-an-spa-part-iii/
/*
require.ensure([], function(require) {
	require('textangular');
	// https://github.com/fraywing/textAngular/issues/842#issuecomment-132523555
	require('textangular/dist/textAngular-sanitize');

	// angular.module('everlaps.events_admin', ['textAngular']); -> Esto no parece funcionar
});
*/

import MyEventsController from './myevents.controller';
import EventAddController from './event_add.controller';
import EventEditController from './event_edit.controller';
import EventCommonController from './event_common.controller';
import EditInscriptionsController from './edit_inscriptions.controller';
import SendMessageController from './send_message.controller.js';



export default angular.module('everlaps.events_admin', [uiRouter, 'ngFileUpload', 'textAngular', 'xeditable', 'ui.codemirror'/*, 'ui.select'*/])
	.config(routing)
	.controller('MyEventsController', MyEventsController)
	.controller('EventAddController', EventAddController)
	.controller('EventEditController', EventEditController)
	.controller('EventCommonController', EventCommonController)
	.controller('EditInscriptionsController', EditInscriptionsController)
	.controller('SendMessageController', SendMessageController)
	.run(function($templateCache, $window, editableOptions) {
		'ngInject';
		$window.CodeMirror = CodeMirror;

		// http://blog.johnnyreilly.com/2016/05/inlining-angular-templates-with-webpack.html
		$templateCache.put("event_common.html", require("./event_common.html"));

		// angular-xeditable configuration
		editableOptions.theme = 'bs3';
	})
	.name;




// WEBPACK FOOTER //
// ./client/app/backend/events/index.js